export const DEPRECIATION = {
  digital: {
    lambda: 0.12,
    floor: 0.25,
  },
  audible: {
    lambda: 0.14,
    floor: 0.22,
  },
  analogue: {
    end_of_life_years: 15,
    floor: 0.25,
  },
};

export const ADJUSTMENTS = {
  condition: {
    'new': 1.00,
    'condition-like-new': 1.00,
    'used': 0.85,
    'condition-good': 0.85,
    'condition-fair': 0.70,
    'defective': 0.40,
    'condition-poor': 0.40,
    _default: 0.85,
  },
  brand_attractiveness: {
    'deep-and-steep': 1.05,
    'l&b': 1.03,
    'vog': 1.01,
    'alti-2': 1.00,
    'aon2': 0.98,
    'parasport': 0.98,
    'airlogone': 0.98,
    'freefall-data': 0.98,
    _default: 1.00,
    _unknown: 0.95,
  },
  version_penalty: {
    'optima-ii': 0.85,
    'protrack-ii': 0.85,
    'quattro': 0.85,
    'viso-ii': 0.85,
    'ares': 0.85,
    'sonoalti-3': 0.85,
    _default: 1.0,
  },
};

export const MANUFACTURERS = {
  'l&b': {
    brand_key: 'l&b',
    models: {
      'ares-ii':     { new_price_eur: 407, type: 'digital' },
      'viso-ii+':    { new_price_eur: 297, type: 'digital' },
      'altitrack':   { new_price_eur: 320, type: 'digital' },
      'optima-3':    { new_price_eur: 297, type: 'audible' },
      'protrack-3':  { new_price_eur: 352, type: 'audible' },
      'quattro-3':   { new_price_eur: 297, type: 'audible' },
      'optima-ii':   { new_price_eur: 264, type: 'audible' },
      'protrack-ii': { new_price_eur: 308, type: 'audible' },
      'quattro':     { new_price_eur: 264, type: 'audible' },
      'solo-ii':     { new_price_eur: 231, type: 'audible' },
      'viso-ii':     { new_price_eur: 297, type: 'digital' },
      'ares':        { new_price_eur: 407, type: 'digital' },
    },
  },
  'deep-and-steep': {
    brand_key: 'deep-and-steep',
    models: {
      'insight': { new_price_eur: 452, type: 'digital' },
      'orbit':   { new_price_eur: 339, type: 'digital' },
    },
  },
  'alti-2': {
    brand_key: 'alti-2',
    models: {
      'atlas-ii':        { new_price_eur: 374, type: 'digital' },
      'juno-ii':         { new_price_eur: 312, type: 'digital' },
      'mercury-crimson': { new_price_eur: 260, type: 'digital' },
      'mercury-jade':    { new_price_eur: 208, type: 'digital' },
      'galaxy':          { new_price_eur: 187, type: 'analogue' },
    },
  },
  'aon2': {
    brand_key: 'aon2',
    models: {
      'x2':                { new_price_eur: 451, type: 'digital' },
      'x0':                { new_price_eur: 132, type: 'digital' },
      'brilliant-pebbles': { new_price_eur: 132, type: 'audible' },
    },
  },
  parasport: {
    brand_key: 'parasport',
    models: {
      'altix':    { new_price_eur: 213, type: 'digital' },
      'aeronaut': { new_price_eur: 191, type: 'analogue' },
    },
  },
  airlogone: {
    brand_key: 'airlogone',
    models: {
      'airlogone-mini':   { new_price_eur: 264, type: 'digital' },
      'airlogone':        { new_price_eur: 344, type: 'digital' },
      'airlogone-motion': { new_price_eur: 370, type: 'audible' },
    },
  },
  'freefall-data': {
    brand_key: 'freefall-data',
    models: {
      'sonoalti-3':  { new_price_eur: 319, type: 'audible' },
      'coloralti-3': { new_price_eur: 385, type: 'audible' },
      'sonoalti-4v': { new_price_eur: 374, type: 'audible' },
      'voxalti':     { new_price_eur: 347, type: 'audible' },
    },
  },
  vog: {
    brand_key: 'vog',
    models: {
      'vog': { new_price_eur: 347, type: 'audible' },
    },
  },
};
